/** «Crear cuenta»: una clínica (15 días de prueba gratis) o un laboratorio (gratis). La clave temporal llega por correo. */
import { useState, type FormEvent } from "react";
import { api, ErrorApi } from "../api.ts";
import { Logo } from "./comun.tsx";

type Tipo = "clinica" | "laboratorio";

export function Registro({ tipoInicial, correoInicial, alVolver }: { tipoInicial?: Tipo; correoInicial?: string; alVolver: () => void }) {
  const [tipo, setTipo] = useState<Tipo>(tipoInicial ?? "clinica");
  const [entidad, setEntidad] = useState("");
  const [nombre, setNombre] = useState("");
  const [email, setEmail] = useState(correoInicial ?? "");
  const [telefono, setTelefono] = useState("");
  const [acepta, setAcepta] = useState(false);
  const [sitio, setSitio] = useState("");   // campo trampa: las personas no lo ven
  const [error, setError] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [hecho, setHecho] = useState<{ enviada: boolean; claveTemporal?: string; email?: string } | null>(null);

  async function crear(e: FormEvent) {
    e.preventDefault();
    setError(""); setEnviando(true);
    try { setHecho(await api("POST", "/api/publico/registro", { tipo, entidad, nombre, email, telefono, acepta, sitio })); }
    catch (err) { setError(err instanceof ErrorApi ? [err.message, ...err.detalles].join(" ") : "No se pudo crear la cuenta."); }
    finally { setEnviando(false); }
  }

  if (hecho) return (
    <main className="login">
      <div className="card" role="status">
        <div className="brand" style={{ color: "var(--accent)" }}><Logo /><span style={{ color: "var(--ink)" }}>Donna</span></div>
        <h1 style={{ fontSize: 22 }}>¡Cuenta creada!</h1>
        {hecho.enviada
          ? <p style={{ margin: 0 }}>Te enviamos un correo a <b>{email}</b> con tu clave temporal. Revisa también la carpeta de spam. Con esa clave entras y Donna te pide crear una propia.</p>
          : <div className="aviso ok">Tu clave temporal es <b className="mono">{hecho.claveTemporal}</b>. Guárdala: no se vuelve a mostrar. Entra con el correo <b>{hecho.email}</b>; Donna te pedirá crear una propia.</div>}
        <button className="btn pri" onClick={alVolver}>Ir a iniciar sesión</button>
      </div>
    </main>
  );

  return (
    <main className="login">
      <form className="card" onSubmit={crear} aria-labelledby="t-registro">
        <div className="brand" style={{ color: "var(--accent)" }}><Logo /><span style={{ color: "var(--ink)" }}>Donna</span></div>
        <h1 id="t-registro" style={{ fontSize: 22 }}>Crear cuenta</h1>
        <div className="seg" role="group" aria-label="Tipo de cuenta">
          <button type="button" aria-pressed={tipo === "clinica"} onClick={() => setTipo("clinica")}>Soy una clínica</button>
          <button type="button" aria-pressed={tipo === "laboratorio"} onClick={() => setTipo("laboratorio")}>Soy un laboratorio</button>
        </div>
        <p className="muted" style={{ margin: 0, fontSize: 14 }}>
          {tipo === "clinica"
            ? "15 días de prueba gratis, sin tarjeta. Después eliges tu plan. Recibes una clave temporal por correo."
            : "Donna para laboratorios es gratis. Recibes y gestionas las órdenes de tus clínicas, con chat, fotos y cuentas, e invitas a tus clínicas a conectarse."}
        </p>
        <label className="campo">{tipo === "clinica" ? "Nombre de la clínica" : "Nombre del laboratorio"}<input required maxLength={120} value={entidad} onChange={(e) => setEntidad(e.target.value)} /></label>
        <label className="campo">Tu nombre<input required maxLength={80} autoComplete="name" value={nombre} onChange={(e) => setNombre(e.target.value)} /></label>
        <label className="campo">Correo (aquí llega la clave)<input type="email" required autoComplete="username" maxLength={120} value={email} onChange={(e) => setEmail(e.target.value)} /></label>
        <label className="campo">Celular (opcional)<input inputMode="tel" maxLength={20} value={telefono} onChange={(e) => setTelefono(e.target.value)} placeholder="09XXXXXXXX" /></label>
        <div aria-hidden="true" style={{ position: "absolute", left: -9999 }}><label>Sitio web<input tabIndex={-1} autoComplete="off" value={sitio} onChange={(e) => setSitio(e.target.value)} /></label></div>
        <label className="fila" style={{ gap: 6, alignItems: "flex-start" }}><input type="checkbox" checked={acepta} onChange={(e) => setAcepta(e.target.checked)} /> <span>Acepto el aviso de privacidad y que Donna me escriba a este correo para darme acceso.</span></label>
        {error && <div className="aviso error" role="alert">{error}</div>}
        <button className="btn pri" disabled={enviando || !acepta}>{enviando ? "Creando…" : "Crear cuenta y enviar la clave"}</button>
        <button type="button" className="enlace" onClick={alVolver}>Ya tengo cuenta: iniciar sesión</button>
      </form>
    </main>
  );
}
